export function getTypeName(key) {
    let typeBasicData = {
        2: { name: '日跑量', unit: 'km' },
        1: { name: '日騎量', unit: 'km' },
        3: { name: '日爬升', unit: 'm' },
        4: { name: '日游量', unit: 'm' }
    }
    
    return { name: typeBasicData[key].name, unit: typeBasicData[key].unit }
}